import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'Recetario de Jugos y Licuados Depurativos',
  description: 'Combinaciones prácticas para apoyar la desinflamación y mejorar tu energía diaria.',
  value: 27,
  image: 'https://cdn.magicpatterns.com/uploads/icQgkqa2UmWnwiGc5AVP9c/20260303_1412_Image_Generation_remix_01kjtayj5seq8r7xzxqcaa8k90.png'
}, {
  number: 2,
  title: 'Guía de Suplementación',
  description: 'Orientación clara sobre los suplementos que pueden apoyar el equilibrio hormonal.',
  value: 19,
  image: 'https://cdn.magicpatterns.com/uploads/a9HzhGfeqsYH8u3y7hWNtu/20260303_1420_Image_Generation_remix_01kjtbc4k1fvvrsg1rk58fgkke.png'
}, {
  number: 3,
  title: 'Lista de Alimentos Antiinflamatorios',
  description: 'Qué incluir y qué reducir para favorecer tu bienestar hormonal.',
  value: 17,
  image: 'https://cdn.magicpatterns.com/uploads/rhh43vqHHStLh1e7WgJ6BM/20260303_1422_Image_Generation_remix_01kjtbfrafez8srx2yzxar6c3m.png'
}, {
  number: 4,
  title: 'Guía de Postres Saludables',
  description: 'Opciones dulces sin afectar tu estabilidad energética.',
  value: 15,
  image: 'https://cdn.magicpatterns.com/uploads/sG2RpCfBRcBcMCMeFX6wow/20260303_1429_Image_Generation_remix_01kjtbxwtqefytp734fst29b3y.png'
}, {
  number: 5,
  title: 'Diario "Volver a Mí"',
  description: 'Herramienta de reflexión para reconectar contigo misma.',
  value: 12,
  image: 'https://cdn.magicpatterns.com/uploads/drnLXiZb945CmC5TgL1AuE/20260303_1434_Image_Generation_remix_01kjtc6gsnf6atqz94k56md8fq.png'
}, {
  number: 6,
  title: 'Meditaciones Guiadas',
  description: 'Audios para reducir estrés y recuperar calma mental.',
  value: 19
}, {
  number: 7,
  title: 'Guía Práctica Antiestrés',
  description: 'Protocolos simples para disminuir cortisol y ansiedad.',
  value: 17
}, {
  number: 8,
  title: 'Reconexión con el Placer y la Sensualidad',
  description: 'Ejercicios para fortalecer tu autoestima y seguridad femenina.',
  value: 15
}, {
  number: 9,
  title: 'Rituales Femeninos para la Menopausia',
  description: 'Prácticas conscientes para vivir esta etapa con mayor conexión interior.',
  value: 12
}, {
  number: 10,
  title: 'Método Batch Cooking',
  description: 'Plan para cocinar en 2 horas y organizar 5 comidas saludables semanales.',
  value: 22
}];
export function BonusSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const totalValue = bonuses.reduce((sum, bonus) => sum + bonus.value, 0);
  return <section className="py-16 px-4 bg-gradient-to-b from-[#C9A96E]/10 via-[#C9A96E]/5 to-[#FAF7F2]" ref={ref} data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-16">
          <span className="inline-block bg-[#C9A96E] text-white text-sm font-bold px-4 py-2 rounded-full mb-4" data-id="element-17">
            🎁 REGALO ESPECIAL
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2926]" data-id="element-18">
            SOLO POR HOY: 10 BONOS DE REGALO
          </h2>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-19">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white rounded-xl p-5 border-2 border-[#C9A96E]/30 hover:border-[#C9A96E]/60 transition-colors shadow-sm" data-id="element-20">
              <div className="flex items-start gap-4" data-id="element-21">
                <div className="flex-shrink-0" data-id="element-22">
                  {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-20 h-24 object-cover rounded-lg shadow-md" data-id="element-23" /> : <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#C9A96E] to-[#B8985D] flex items-center justify-center" data-id="element-24">
                      <GiftIcon className="w-6 h-6 text-white" data-id="element-25" />
                    </div>}
                </div>
                <div className="flex-1" data-id="element-26">
                  <div className="flex items-center gap-2 mb-1" data-id="element-27">
                    <span className="text-xs font-bold text-[#C9A96E] bg-[#C9A96E]/10 px-2 py-0.5 rounded" data-id="element-28">
                      BONUS #{bonus.number}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-[#2D2926] mb-1" data-id="element-29">
                    {bonus.title}
                  </h3>
                  <p className="text-[#2D2926]/70 text-sm mb-2" data-id="element-30">
                    {bonus.description}
                  </p>
                  <p className="text-sm" data-id="element-31">
                    <span className="text-[#2D2926]/50 line-through" data-id="element-32">
                      Valor: ${bonus.value}
                    </span>
                    <span className="ml-2 text-[#6B8F5E] font-bold" data-id="element-33">
                      (GRATIS)
                    </span>
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="bg-gradient-to-r from-[#C9A96E] to-[#B8985D] rounded-2xl p-6 text-center text-white shadow-xl" data-id="element-34">
          <p className="text-lg mb-2" data-id="element-35">Valor Total de los Bonos:</p>
          <p className="text-3xl font-bold mb-2" data-id="element-36">
            <span className="line-through opacity-70" data-id="element-37">${totalValue}</span>
          </p>
          <p className="text-2xl font-bold" data-id="element-38">¡INCLUIDO GRATIS HOY!</p>
        </motion.div>
      </div>
    </section>;
}